import styled from "styled-components";

export const ListContent = styled.div`
  .ti-list-item-content {
    background: #ffffff;
  }
  .ti-list-item {
    border: none;
  }
`;
